<template>
  <div class="content-main">

    <van-popup v-model="loading" class="pop-loading">
      <div class="loading">
        <span>加载中</span>
        <van-loading type="spinner" />
      </div>
    </van-popup>

    <div class="shanzha">

      <div class="infos" v-if="!loading">
        <div class="info-item" v-for="(info, index) in infos" :key="info.id">
          <div class="receiver-and-date flex-box">
            <div class="receiver">To：{{info.receiver}}</div>
            <div class="date">{{info.date}}</div>
          </div>
          <div class="info-content" v-if="info.status == 0">{{info.content}}</div>
          <div class="info-content" v-if="info.status == 5" style="color:#dc6263">本条留言正在审核中，审核通过以后，留言内容自动公开。</div>
          <div class="info-content" v-if="info.status == 7" style="color:#dc6263">本条留言存在不符合社区规范的内容，需修改。请修改留言内容，并重新提交审核。</div>
          <div class="msg-entry flex-box">
            <span class="msg-btn" @click="goMessageCheckSpecific(info.receiver)">查看详情</span>
          </div>
        </div>
        <div class="no-more">{{(infos.length == 0) ? "你还没有写过留言哦～" : "没有更多了～"}}</div>
      </div>

    </div>

    <!-- <van-tabbar v-model="tabActive" active-color="#f1b8af">
      <van-tabbar-item icon="wap-home" @click="goHome()">首页</van-tabbar-item>
      <van-tabbar-item icon="eye-o" @click="goMessageCheck()">看留言</van-tabbar-item>
      <van-tabbar-item icon="envelop-o" @click="goMessageCreate()">写留言</van-tabbar-item>
      <van-tabbar-item icon="manager-o">个人中心</van-tabbar-item>
    </van-tabbar> -->

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Popup, Dialog } from 'vant'

export default{
  data(){
    return {
      loading: true,
      infos: [],
      tabActive: 3
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goHome(){
      this.$router.replace("/")
    },
    goMessageCreate(){
      if(this.$store.state.userinfo.silent == 1){
        Toast('系统正在维护中，暂时无法创建留言，仅可查看留言～')
      }else{
        this.$router.replace("/message_create_combo")
      }
    },
    goMessageCheck(){
      this.$router.replace("/message_check")
    },
    goMessageCheckSpecific(receiver){
      this.$router.replace("/message_check?receiver=" + receiver)
    },
    getRecords(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/garden/get_userself_msgs_v2', {openid: openid}, res => {
        if(res.code == 200){
          this.infos = res.msgs
          this.loading = false
        }
      })
    },
    wxConfigInit(){
      this.$api.get('/shanzhadao/get_wx_js_config_shanzhadao', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });

          let share_nickname = this.$store.state.userinfo.nickname
          let share_title = `${share_nickname}给你写了一条留言～`
          let share_desc = '这里有你的故事'
          let share_link = this.$store.state.siteDomain
          let share_img = this.$store.state.userinfo.headimg

          let openid = this.$store.state.userinfo.openid
          let site_code = this.$store.state.siteCode
          let _this = this
          //分享到朋友圈（即将废弃）
          wx.onMenuShareTimeline({
            title: share_title, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          //分享给朋友（即将废弃）
          wx.onMenuShareAppMessage({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          // //分享给朋友
          // wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          //   wx.updateAppMessageShareData({
          //     title: share_title, // 分享标题
          //     desc: share_desc, // 分享描述
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });
          //
          // //分享到朋友圈
          // wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          //   wx.updateTimelineShareData({
          //     title: share_title, // 分享标题
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });

        }
      })
    }
  },
  mounted(){
    this.getRecords()
    this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f6f6f6;color:#f1b8af;}
.shanzha{padding:15px;padding-top:25px;padding-bottom:70px;}
.van-popup{width:70%;padding:20px;}
.pop-loading{
  background:rgba(255,255,255,0);
  color:#fff;
}
.content-main .loading{
  font-size:13px;
  padding:20;
}
.content-main .loading .van-loading{
  margin:0 auto;
  margin-bottom:15px;
  margin-top:30px;
}
.infos{text-align:left;}
.infos .info-item{
  color:#666;font-size:13px;margin-bottom:15px;background:#fff;padding:10px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);transition: 0.3s;border-radius: 5px;
}
.infos .info-item .receiver-and-date{
  justify-content:space-between;margin-bottom:10px;font-size:12px;color:#8590a6;
  border-bottom:1px solid #f0f0f0;padding-bottom:5px;
}
.infos .info-item .info-content{ padding-bottom:5px;}
.infos .info-item .msg-entry{justify-content:flex-end;}
.infos .info-item .msg-entry .msg-btn{
  color:#f1b8af;padding:2px 5px;border:1px solid #f1b8af;
  border-radius:15px;font-size:10px;
}
.infos .no-more{font-size:12px;color:#8590a6;text-align:center;margin-top:20px;}
</style>
